import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "../lib/api";
import { Brand } from "../components/Logo";
import { AideBloc } from "../components/AideContent";

export default function Aide() {
  const [aide, setAide] = useState(null);
  const [erreur, setErreur] = useState(false);
  useEffect(() => {
    api.get("/aide").then((r) => setAide(r.data)).catch(() => setErreur(true));
  }, []);
  const blocs = Array.isArray(aide?.blocs) ? aide.blocs : [];
  const c = new URLSearchParams(window.location.search).get("c");
  const retour = c ? `/?c=${encodeURIComponent(c)}` : "/";

  return (
    <div className="min-h-screen bg-ink">
      <header className="sticky top-0 z-50 border-b border-chalk/5 bg-ink/80 backdrop-blur-xl">
        <div className="mx-auto flex max-w-3xl items-center justify-between gap-3 px-4 py-2.5 sm:px-6">
          <Brand />
          <Link to={retour} data-testid="aide-back-link" className="inline-flex shrink-0 items-center gap-1 rounded-full border border-chalk/20 px-3 py-2 text-sm text-chalk transition-colors hover:border-lime hover:text-lime">
            <ArrowLeft className="h-4 w-4" />Retour
          </Link>
        </div>
      </header>
      <main data-testid="aide-page" className="mx-auto max-w-3xl px-4 pb-20 pt-8 sm:px-6">
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-lime">Aide pour les parents</p>
        {erreur && <p data-testid="aide-error" className="mt-6 text-chalk">Le guide n'a pas pu être chargé. Réessayez dans un instant.</p>}
        {!aide && !erreur && <p className="mt-6 text-dim">Chargement du guide…</p>}
        {aide && <h1 data-testid="aide-title" className="mt-3 font-display text-4xl uppercase leading-[0.95] text-chalk sm:text-5xl">{aide.titre}</h1>}
        {blocs.map((b, i) => <AideBloc key={i} b={b} i={i} />)}
        {aide && (
          <Link to={retour} data-testid="aide-cta-repondre" className="mt-12 flex w-full items-center justify-center rounded-full bg-lime px-6 py-4 font-semibold text-ink transition-transform duration-200 hover:-translate-y-0.5">
            J'ai compris, je réponds à la convocation
          </Link>
        )}
      </main>
    </div>
  );
}
